export default object => typeof object
